import Axios from "axios";
import _ from "lodash";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getNotes(id, page) {
        return Axios.get(`${baseURL}record/client-document/${id}`, {
            params: { type: "remark", page }
        }).then(response => response.data.response);
    },
    getPopupNotes(id) {
        return Axios.get(`${baseURL}actor/client/${id}/popup-notes`).then(
            response => response.data.response
        );
    },
    deleteNote(noteId) {
        return Axios.delete(`${baseURLci}client/notes/remove`, {
            params: { id: noteId }
        }).then(response => response.data.response);
    },
    addNote(params) {
        let formData = new FormData();

        _.forEach(params, function (value, key) {
            formData.append(key, value);
        });

        return Axios.post(`${baseURLci}client/notes/save`, formData).then(
            response => response.data
        );
    }
};
